(function() {
'use strict';

angular.module('TR')
    .directive('lightboxConfirmation', lightboxConfirmation);

function lightboxConfirmation() {
    return {
        restrict: 'E',
        replace: true,
        transclude: {
        // Modal title may be provided either by `headerText` attribute
        // or named transclusion i.e. `<modal-title> Details </modal-title>`
            title: '?modalTitle'
        },
        scope: {
            show: '=',
            confirm: '&',
            confirmText: '@',
            confirmCss: '@',
            reject: '&',
            rejectText: '@',
            rejectCss: '@',
            headerText: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=LightboxConfirmation',

        link(scope, el, attrs) {
            scope.confirmCss = angular.isUndefined(attrs.confirmCss) ? 'secondary' : attrs.confirmCss;
            scope.rejectCss = angular.isUndefined(attrs.rejectCss) ? '' : attrs.rejectCss;


            scope.ok = function() {
                scope.show = false;
                scope.confirm();
            };

            scope.cancel = function() {
                scope.show = false;

                //check the function has been specified before calling it
                if (angular.isDefined(attrs.reject)) {
                    scope.reject();
                }
            };

            scope.closeClicked = function(e) {
                e.preventDefault();
                scope.cancel();
            };

            const overlay = el;

            scope.$watch('show', function(v, o) {
                if (v == null || v === o) {
                    return;
                }
                if (v) {
                    //disable browser scroll bar
                    $('body').css('overflow', 'hidden');

                    overlay.fadeIn(300, 'swing', function() {
                        $(window).resize(); //not particularly thrilled with this
                    });
                } else {
                    overlay.fadeOut(200, 'swing');

                    // re-enable browser scroll bar
                    $('body').css('overflow', '');
                }
            });
        }

    };
}
})();
